'use client'

import '@district-core/utils/polyfills.ts'

import type { PropsWithChildren } from 'react'

type Props = PropsWithChildren

export function CoreProvidersClient({ children }: Props) {
  return children
}
